/* eslint-disable react/jsx-pascal-case */
import BuildingInsights_116 from '@carbon/icons-react/es/building--insights-1/16';
import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { CellRendererParams } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;

const TextWrapper = styled(Typography.Text).attrs({
  ellipsis: { tooltip: true },
})`
  width: 100%;
`;

export const PartnerNameRenderer: FC<CellRendererParams> = ({ data }) => (
  <Wrapper>
    <Avatar
      size="large"
      icon={<BuildingInsights_116 />}
      src={data.companyLogoUrl}
    />
    <TextWrapper>{data.companyName}</TextWrapper>
  </Wrapper>
);
